import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { ProductScope, ProductService, SemanticPathService } from '@spartacus/core';
import { combineLatest, filter, map, Observable, of, switchMap, take } from 'rxjs';

export const ProductNotFoundGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const semanticPathService = inject(SemanticPathService);
  const productCode = route.paramMap.get('productCode');
  const productService = inject(ProductService);

  if (!productCode) {
    return of(router.parseUrl(semanticPathService.get('notFound')));
  }

  return productService.get(productCode, ProductScope.DETAILS).pipe(
    switchMap(() => {
      return combineLatest({
        isSuccess: productService.isSuccess(productCode, ProductScope.DETAILS),
        hasError: productService.hasError(productCode, ProductScope.DETAILS),
      });
    }),
    filter(({ isSuccess, hasError }) => isSuccess || hasError),
    take(1),
    map(({ isSuccess }) => {
      if (!isSuccess) {
        return router.parseUrl(semanticPathService.get('notFound'));
      }

      return true;
    }),
  );
};
